export default {
    get(type, id) {
        return window.axios.get('/api/attachments', {
            params: {
                type,
                id,
            }
        });
    },

    store(data) {
        return window.axios.post('/api/attachments', data);
    },

    delete(attachmentId) {
        return window.axios.delete(`/api/attachments/${attachmentId}`);
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/services/AttachmentsService.js